/* eslint-disable react-hooks/rules-of-hooks */
import Image from "next/image";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";

const Properties = ({ bookingData, setRating, handleOpenRating, rating, dataFilter, setDataFilter, setLoading, loading, currentPage, activeTab, dataOne, handleViewDetails }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (bookingData?.length === 0) {
    return (
      <div className="text-center">
        <Image
          width={300}
          height={300}
          className="rounded-4 col-12 js-lazy"
          // src={`/img/hotels/1.png`}
          src="/img/general/nodata.png"
          alt="image"
          style={{
            width: '200px',
          }}
        />
        <h4 className="text-center">No Booking</h4>
      </div>
    );
  }


  const handleRatingClick = (newRating, index, id, type) => {
    setCurrentIndex(index);
    setDataFilter({ ...dataFilter, ['bookingId']: id, ['type']: type, ['rating']: newRating });
    setRating(newRating);
    handleOpenRating();
  };


  return (
    <>
      {activeTab === 0 ?
        bookingData?.slice(0, 50).map((item, index) => (
          <div className="col-12" key={item._id} style={{
            backgroundColor: '#d9d9d92b',
            marginBottom: '12px'
          }}>
            <div className="row x-gap-20 y-gap-30">

              {/* End col */}

              <div className="col-md">
                <div style={{ justifyContent: "space-between", display: "flex" }}>
                  <h3 className="text-18 lh-14 fw-500">{item?.name}</h3>

                  {/* {item?.bookingStatus === 1 && <div className="star-rating">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      className={`star ${item?.rating !== 0 ? star <= item?.rating ? 'filled' : '' : star <= rating && currentIndex === index ? 'filled' : ''}`}
                      onClick={() => item?.rating === 0 ? handleRatingClick(star, index, item?._id, item?.type) : alert("You've already assessed your previous interaction.")}
                    >
                      <FontAwesomeIcon icon={faStar} />
                    </span>
                  ))}
                </div>} */}

                </div>


                <div className="row x-gap-10 y-gap-10 items-center pt-5">
                  <div className="col-auto">
                    <p className="text-14">
                      {item?.location}

                    </p>
                  </div>


                  <h3 className="text-18 lh-14 fw-500">
                    <div className="fw-500 text-light-1"><span className="fw-500 text-dark-1">

                      <span>  {moment(item?.bookingDate).format("dddd")}</span>
                      <span>  {moment(item?.bookingDate).format("MMM Do YY")} </span>
                      <span>  {item?.type === 6 || item?.type === 4 ? `${item?.bookingTime ? item?.bookingTime : ""}` : ''}</span>

                    </span></div>

                  </h3>

                  <h3 className="text-18 lh-14 fw-500">
                    {item?.referenceNumber && item?.referenceNumber?.trim() !== "" && (
                      <div className="fw-400 text-light-1">Booking ID:<span className="ml-5 fw-500 text-dark-1">
                        {item?.referenceNumber}
                      </span></div>
                    )}
                  </h3>

                  <div className="d-flex items-center">
                    <div className="col-auto mr-20">

                      {dataOne?.type === "" ? "" :
                        <div
                          className="text-14 lh-14 text-light-1"

                        >
                          {item?.bookingStatus === 1 ? <span className="fw-500 font-monospace px-2 py-1 rounded-1 text-white bg-success">Confirmed</span> : item?.bookingStatus === 0 ? <span className="fw-500 font-monospace text-white bg-danger py-1 px-2 rounded-1">
                            {item?.type === 10 ? 'Created' : 'Pending'}
                          </span> : item?.bookingStatus === 6 ? <span className="fw-500 font-monospace text-white bg-danger py-1 px-2 rounded-1">Request for Cancelled</span> : item?.bookingStatus === 7 ? <span className="fw-500 font-monospace text-white bg-danger py-1 px-2 rounded-1">Cancelled</span> : ""}
                        </div>}
                    </div>

                    <div className="">
                      <button className="btn btn-primary btn-sm" style={{
                        backgroundColor: '#6DC8BF',
                        border: 'none'
                      }} onClick={() => handleViewDetails(index, item)}><a href="#">View Details</a></button>

                    </div>
                  </div>
                </div>

              </div>


              <div className="col-md-auto">
                <div className="cardImage ratio ratio-1:1 w-200 md:w-1/1 rounded-4">
                  <div className="cardImage__content">
                    <img src={`${process.env.IMAGE_BASE_URL}/${item?.image}`} alt="image" width={300} height={300} className="rounded-4 col-12 js-lazy" style={{ clipPath: 'polygon(40% 0, 100% 0, 100% 100%, 0 100%)' }} />
                  </div>
                </div>
              </div>
            </div>
          </div >
        )) :
        bookingData?.slice(0, 50).map((item, index) => (
          <div className="col-12" key={item._id} style={{
            backgroundColor: '#d9d9d92b',
            marginBottom: '12px'
          }}>
            <div className="row x-gap-20 y-gap-30">

              {/* End col */}

              <div className="col-md">
                <div style={{ justifyContent: "space-between", display: "flex" }}>
                  <h3 className="text-18 lh-14 fw-500">{item?.name}</h3>

                  {/* {item?.bookingStatus === 1 && <div className="star-rating">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <span
                        key={star}
                        className={`star ${item?.rating !== 0 ? star <= item?.rating ? 'filled' : '' : star <= rating && currentIndex === index ? 'filled' : ''}`}
                        onClick={() => item?.rating === 0 ? handleRatingClick(star, index, item?._id, item?.type) : alert("You've already assessed your previous interaction.")}
                      >
                        <FontAwesomeIcon icon={faStar} />
                      </span>
                    ))}
                  </div>} */}

                </div>


                <div className="row x-gap-10 y-gap-10 items-center pt-5">
                  <div className="col-auto">
                    <p className="text-14">
                      {item?.location}

                    </p>
                  </div>


                  <h3 className="text-18 lh-14 fw-500">
                    <div className="fw-500 text-light-1"><span className="fw-500 text-dark-1">

                      <span>  {moment(item?.bookingDate).format("dddd")}</span>
                      <span>   {moment(item?.bookingDate).format("MMM Do YY")} </span>
                      <span>  {item?.type === 6 || item?.type === 4 ? `${item?.bookingTime ? item?.bookingTime : ""}` : ''}</span>


                    </span></div>

                  </h3>

                  <h3 className="text-18 lh-14 fw-500">
                    {item?.referenceNumber && item?.referenceNumber?.trim() !== "" && (
                      <div className="fw-400 text-light-1">Booking ID:<span className="ml-5 fw-500 text-dark-1">
                        {item?.referenceNumber}
                      </span></div>
                    )}

                  </h3>

                  <div className="d-flex items-center">
                    <div className="col-auto mr-20">

                      {dataOne?.type === "" ? "" :
                        <div
                          className="text-14 lh-14 text-light-1"

                        >
                          {item?.bookingStatus === 1 ?
                            <span className="fw-500 font-monospace px-2 py-1 rounded-1 text-white bg-success">Confirmed</span>
                            :
                            item?.bookingStatus === 0 ?
                              <span className="fw-500 font-monospace text-white bg-warning px-2 py-2 rounded-1">{item?.type === 10 ? 'Created' : 'Pending'}</span>
                              :
                              item?.bookingStatus === 6 ?
                                <span className="fw-500 font-monospace text-white bg-danger py-1 px-2 rounded-1">Request for Cancelled</span>
                                : item?.bookingStatus === 7 ?
                                  <span className="fw-500 font-monospace text-white bg-danger py-1 px-2 rounded-1">Cancelled</span>
                                  :
                                  ""
                          }
                        </div>}
                    </div>

                    <div className="">
                      <button className="btn btn-primary btn-sm" style={{
                        backgroundColor: '#6DC8BF',
                        border: 'none'
                      }} onClick={() => handleViewDetails(index, item)}><a href="#">View Details</a></button>

                    </div>
                  </div>


                </div>

              </div>


              <div className="col-md-auto">
                <div className="cardImage ratio ratio-1:1 w-200 md:w-1/1 rounded-4">
                  <div className="cardImage__content">
                    <img src={`${process.env.IMAGE_BASE_URL}/${item?.image}`} alt="image" width={300} height={300} className="rounded-4 col-12 js-lazy" style={{ clipPath: 'polygon(40% 0, 100% 0, 100% 100%, 0 100%)' }} />
                  </div>
                </div>
              </div>

            </div>
            {/* End .row */}
            {/* <div className="border-top-light mt-30 mb-20" /> */}
          </div >
        ))}
    </>
  );
};

export default Properties;
